const CRAWLER_USER_AGENT_MARKERS = [
  "googlebot",
  "bingbot",
  "applebot",
  "duckduckbot",
  "yandexbot",
  "baiduspider",
  "bytespider",
  "petalbot",
  "gptbot",
  "claudebot",
  "ccbot",
  "oai-searchbot",
  "perplexitybot",
  "amazonbot",
  "twitterbot",
  "slackbot",
  "discordbot",
  "facebookexternalhit",
  "meta-externalagent",
  "meta-externalfetcher",
  "google-inspectiontool",
  "crawler",
  "spider",
  "slurp",
] as const;

/**
 * Detect automated crawlers that should not trigger optional client-side work.
 * This is a load-shedding hint, not an authorization boundary.
 */
export function isCrawlerUserAgent(userAgent: string | null | undefined): boolean {
  if (!userAgent) return false;

  const normalizedUserAgent = userAgent.toLowerCase();
  return CRAWLER_USER_AGENT_MARKERS.some((marker) => normalizedUserAgent.includes(marker));
}
